import React from "react";
import { Link, useLocation, useOutletContext } from "react-router-dom";
import { CalendarDays, ChevronRight, ExternalLink, ShieldCheck } from "lucide-react";
import "../admin.css";

const pageNames = { "/admin": "Dashboard", "/admin/user": "Users", "/admin/practice": "Questions", "/admin/post": "Posts", "/admin/product": "Products", "/admin/product/price": "Dynamic Price", "/admin/onboarding-analytics": "Onboarding Analytics", "/admin/personalisation": "Personalisation" };

export default function Navbaradmin() {
  const { pathname } = useLocation();
  const { role } = useOutletContext() || {};
  const pageName = pageNames[pathname] || "Admin workspace";
  const today = new Date().toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  return (
    <header className="admin-topbar">
      <nav className="admin-breadcrumb" aria-label="Breadcrumb"><Link to="/admin">Workspace</Link><ChevronRight size={14} aria-hidden="true" /><span aria-current="page">{pageName}</span></nav>
      <div className="admin-topbar-right"><span className="admin-date"><CalendarDays size={15} />{today}</span><Link to="/dashboard" className="admin-topbar-link">View platform <ExternalLink size={14} /></Link><span className="admin-role" title={Number(role) === 1 ? "Workspace owner" : "Administrator"}><ShieldCheck size={16} /><span>{Number(role) === 1 ? "Owner" : "Admin"}</span></span></div>
    </header>
  );
}
